import {Tweener} from '../Tweener';

export class DisplayShortcuts {

	constructor () {
			console.log('This is an static class and should not be instantiated.')
	}

	/**
	 * Registers all the special properties to the Tweener class, so the Tweener knows what to do with them.
	 */
	public static init():void {
		Tweener.registerSpecialProperty('_frame', DisplayShortcuts._frame_get, DisplayShortcuts._frame_set);
		Tweener.registerSpecialProperty('_autoAlpha', DisplayShortcuts._autoAlpha_get, DisplayShortcuts._autoAlpha_set);
		Tweener.registerSpecialProperty('_scale', DisplayShortcuts._scale_get, DisplayShortcuts._scale_set);
	}

	public static _scale_get (p_obj:any, p_parameters:any[], p_extra:any = null):number {
		return p_obj.scale.x > p_obj.scale.y ? p_obj.scale.x : p_obj.scale.y;
	}

	public static _scale_set (p_obj:any, p_value:number, p_parameters:any[], p_extra:any = null):void {
		p_obj.scale.set(p_value, p_value);
	}

	public static _frame_get (p_obj:any, p_parameters:any[], p_extra:any = null):number {
		return p_obj.currentFrame;
	}

	public static _frame_set (p_obj:any, p_value:number, p_parameters:any[], p_extra:any = null):void {
		p_obj.gotoAndStop(Math.round(p_value));
	}


	public static _autoAlpha_get (p_obj:any, p_parameters:any[], p_extra:any = null):number {
		return p_obj.alpha;
	}

	public static _autoAlpha_set (p_obj:any, p_value:number, p_parameters:any[], p_extra:any = null):void {
		p_obj.alpha = p_value;
		p_obj.visible = p_value > 0;
	}
}
